import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-business-legal-protection-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_522_2447)">
        <path
          d="M9.75 17.25H21.75C22.1478 17.25 22.5294 17.408 22.8107 17.6893C23.092 17.9706 23.25 18.3522 23.25 18.75V21.75C23.25 22.1478 23.092 22.5294 22.8107 22.8107C22.5294 23.092 22.1478 23.25 21.75 23.25H9.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 17.25H9.75C10.1478 17.25 10.5294 17.408 10.8107 17.6893C11.092 17.9706 11.25 18.3522 11.25 18.75V21.75C11.25 22.1478 11.092 22.5294 10.8107 22.8107C10.5294 23.092 10.1478 23.25 9.75 23.25H0.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.75 17.25V23.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 20.25H2.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.25 2.25H21.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M12 0.75V14.25"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9 17.25C9 16.4544 9.31607 15.6913 9.87868 15.1287C10.4413 14.5661 11.2044 14.25 12 14.25C12.7956 14.25 13.5587 14.5661 14.1213 15.1287C14.6839 15.6913 15 16.4544 15 17.25H9Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M0.75 9.75L4.5 2.25L8.25 9.75"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M15.75 9.75L19.5 2.25L23.25 9.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.25 9.75C8.25 10.7446 7.85491 11.6984 7.15165 12.4017C6.44839 13.1049 5.49456 13.5 4.5 13.5C3.50544 13.5 2.55161 13.1049 1.84835 12.4017C1.14509 11.6984 0.75 10.7446 0.75 9.75H8.25Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M23.25 9.75C23.25 10.7446 22.8549 11.6984 22.1517 12.4017C21.4484 13.1049 20.4946 13.5 19.5 13.5C18.5054 13.5 17.5516 13.1049 16.8483 12.4017C16.1451 11.6984 15.75 10.7446 15.75 9.75H23.25Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_522_2447">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class BusinessLegalProtectionIconComponent extends BaseIconComponent {}
